import { when, set, unset } from 'cerebral/operators'
import { parallel } from 'cerebral'
import { state, props } from 'cerebral/tags'
import filterCompute from '../computed/filterCompute'
import valueExistsInSelected from '../actions/valueExistsInSelected'
import valueExistsInOptions from '../actions/valueExistsInOptions'
import hasFocusedOption from '../actions/hasFocusedOption'
import rules from '../helpers/rules'

/**
 * handles return stroke. Can be in dropbox or
 * just via input
*/
const onNewValue = hooks => {
  return [
    set(props`payload`, state`selectr.${props`namespace`}.payload`),
    hasFocusedOption,
    {
      true: [
        ({ state, props, resolve, path }) => {
          const filteredOptions = resolve.value(filterCompute(props.namespace))

          const option = filteredOptions[props.focusedOption]
          state.splice(`selectr.${props.namespace}.options`, option.index, 1)
          state.push(`selectr.${props.namespace}.selected`, {
            label: option.label
          })
          return { value: option.label }
        },
        set(state`selectr.${props`namespace`}.focusedOption`, null),
        set(state`selectr.${props`namespace`}.input.value`, ''),
        ...hooks.onSelectOption
      ],
      false: [
        valueExistsInSelected,
        {
          true: [
            set(
              state`selectr.${props`namespace`}.selected.${props`index`}.flash`,
              true
            ),
            set(state`selectr.${props`namespace`}.input.value`, '')
          ],
          false: [
            valueExistsInOptions,
            {
              true: [
                ({ state, props, path }) => {
                  // push option to selected
                  const options = state.get(
                    `selectr.${props.namespace}.options`
                  )
                  const option = options[props.index]
                  state.push(`selectr.${props.namespace}.selected`, {
                    label: option.label
                  })
                  // remove from options
                  state.splice(
                    `selectr.${props.namespace}.options`,
                    props.index,
                    1
                  )
                },
                set(state`selectr.${props`namespace`}.input.value`, ''),
                ...hooks.onSelectOption
              ],
              false: [
                ({ state, props, path }) => {
                  const { value } = props

                  if (state.get(`selectr.${props.namespace}.createTags`)) {
                    const validationRules = state.get(
                      `selectr.${props.namespace}.validationRules`
                    )
                    const isValid = validationRules.reduce(
                      (acc, validation) => {
                        if (rules[validation]) {
                          const valid = rules[validation](value)
                          if (!valid) {
                            acc.push({ validation, value })
                          }
                        }
                        return acc
                      },
                      []
                    )

                    if (isValid.length > 0) {
                      return path.notValid({ errors: isValid })
                    } else {
                      state.push(`selectr.${props.namespace}.selected`, {
                        label: value
                      })
                      return path.created()
                    }
                  } else {
                    return path.notCreated()
                  }
                },
                {
                  created: [
                    set(state`selectr.${props`namespace`}.input.value`, ''),
                    unset(state`selectr.${props`namespace`}.input.error`),
                    ...hooks.onOptionCreated
                  ],
                  notCreated: [
                    set(state`selectr.${props`namespace`}.input.value`, ''),
                    unset(state`selectr.${props`namespace`}.input.error`)
                  ],
                  notValid: [
                    set(
                      state`selectr.${props`namespace`}.input.error`,
                      props`errors`
                    )
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    set(state`selectr.${props`namespace`}.performTagUnfocus`, false),
    set(state`selectr.${props`namespace`}.optionsClosed`, true)
  ]
}

export default onNewValue
